import { Component, OnInit } from '@angular/core';
import { AuthService } from '../../services/auth.service';
import { NgForm } from '@angular/forms';
import { Router } from '@angular/router';

@Component({
  selector: 'app-login',
  templateUrl: './login.component.html',
  styleUrls: ['./login.component.scss']
})
export class LoginComponent implements OnInit {

  public email: string;

  public password: string;

  public invalid = false;

  constructor(private authService: AuthService, private router: Router) { }

  public ngOnInit(): void {

  }

  public login(form: NgForm): void {
    if (form.invalid) {
      return;
    }

    this.authService
      .login(this.email, this.password)
      .subscribe(() => {
        // Required check when logging in or else the authGuard will conflict as they are async calls.
        this.authService
          .hasValidSession()
          .then(() => {
            this.router.navigate(['main']);
          });

      }, () => {
        this.invalid = true;
      });
  }

}
